const baseTableMixin = {
  data() {
    return {
      // 查询表单
      tableForm: {},
      // 表格数据
      tableData: [],
      tableLoading: false,

      // 当前表格 内容的筛选条件（点击搜索后的条件）
      tableCurrentQuery: {},

      // 分页相关
      tableTotal: 0,
      tableCurrentPage: 0,
      tablePageQuery: {
        pageSize: 60,
        pageNo: 1
      }
    };
  },
  computed: {
    tableSearchQuery: {
      get: function() {
        let pure = {
          ...this.tableForm,
          ...this.tablePageQuery
        };
        for (let k in pure) {
          if (pure[k] === '' || pure[k] === undefined || pure[k] == null) {
            delete pure[k];
          }
        }
        return pure;
      },
      set: function() {
        throw new Error('tableSearchQuery 是 form 和 page 分页的计算');
      }
    }
  }
};
export default baseTableMixin;
